export const FONT_DEFAULT_COLOR = '#34414A';
export const PRIMARY_COLOR = '#3396D4';
export const ACCENT_COLOR = '#28C77E';
export const DEFAULT_GREY = '#98A1A9';
export const RING_AVAILABLE_COLOR = '#FFFFFF';
export const RING_RESERVED_COLOR = '#FFC530';
export const RING_UNAVAILABLE_COLOR = '#EA4242';
